import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { adminMe, adminLogin as apiLogin, adminLogout as apiLogout, getToken } from "./adminApi";

const AuthCtx = createContext(null);
export const useAdminAuth = () => useContext(AuthCtx);

export const AdminAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=checking, false=guest, object=admin
  const check = useCallback(async () => {
    if (!getToken()) return setUser(false);
    try {
      setUser(await adminMe());
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = async (email, password) => {
    const u = await apiLogin(email, password);
    setUser(u);
    return u;
  };
  const logout = async () => {
    await apiLogout();
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, login, logout, refresh: check }}>{children}</AuthCtx.Provider>;
};
